<template>
  <s-modal>
    <form class="col gap-50" @submit.prevent="confirmDelete">
      <section class="header row space-between align-center">
        <span class="font-18">Delete Account</span>
        <button class="center" @click="close">
          <s-icon color="grey">close</s-icon>
        </button>
      </section>
      <section class="body">
        <div class="opacity-60 font-14">
          Are you sure you want to delete the account for <strong>{{ requestData?.email }}</strong>? This action cannot be undone and will permanently delete all user data.
        </div>
      </section>
      <section class="footer row gap-20 justify-end">
        <s-btn type="button" @click="close">
          Cancel
        </s-btn>
        <s-btn type="submit" class="red white--text" :loading="loading">
          Delete Account
        </s-btn>
      </section>
    </form>
  </s-modal>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import { post } from '@/assets/functions';

const store = useStore();
const $toast = useToast();

const loading = ref(false);
const requestData = computed(() => {
  const modalState = store.state.modals.deleteAccountConfirmation;
  return modalState && typeof modalState === 'object' ? modalState.request : null;
});

const confirmDelete = async () => {
  if (!requestData.value) return;

  loading.value = true;
  const onSuccessCallback = requestData.value.onSuccess;
  
  try {
    const response = await post(`/api/users/deletion-requests/${requestData.value.id}/execute`);
    
    if (response && response.status === 'ok') {
      const message = response.message || 'Account deleted successfully.';
      if (response.emailSent === false) {
        $toast.warning(message, {
          position: 'top-right',
          duration: 7000
        });
      } else {
        $toast.success(message, {
          position: 'top-right',
          duration: 5000
        });
      }
      
      if (onSuccessCallback && typeof onSuccessCallback === 'function') {
        await onSuccessCallback();
      }
      
      close();
    } else {
      console.error('Failed to delete account:', response);
      $toast.error(response?.message || 'Failed to delete account. Please try again.', {
        position: 'top-right',
        duration: 5000
      });
    }
  } catch (error) {
    console.error('Error deleting account:', error);
    $toast.error('Failed to delete account. Please try again.', {
      position: 'top-right',
      duration: 5000
    });
  } finally {
    loading.value = false;
  }
};

const close = () => {
  store.commit("modals/deleteAccountConfirmationModal", false);
};
</script>

